// -----------------------------------------------
// apply.js
// お申込みボタン関連の処理
// -----------------------------------------------
// お申込みボタンにパラメーター引き継ぎ

function init() {
  if (document.querySelector('.p-applyBtn')) {
    updateApplyLinks();
    bindApplyConversion();
  }
}

// 申込リンクに現在のURLパラメータを引き継ぐ
function updateApplyLinks() {
  const queryString = window.location.search; // 現在のURLのパラメータ
  const applyLinks = document.querySelectorAll('.p-applyBtn a');

  applyLinks.forEach(link => {
    if (queryString) {
      const separator = link.href.includes('?') ? '&' : '?';
      link.href += separator + queryString.substring(1); // "?" を除いて結合
    }
  });
}

// -----------------------------------------------
// ここから下は媒体別発火処理
// ※ お申込みボタンが押されたときに媒体側に発火通知が必要な場合は追加
// -----------------------------------------------

/** 来訪元媒体を company_cd で判定（キー付きパラメータ想定） */
function detectMedium() {
  const q = window.location.search || '';
  // 例: ?001, &001, ?001&foo=bar などを検出
  if (/(?:^\?|&)company_cd=000534(?:&|$)/.test(q)) return "yahoo";
  if (/(?:^\?|&)company_cd=000535(?:&|$)/.test(q)) return "meta";
  if (/(?:^\?|&)company_cd=000533(?:&|$)/.test(q)) return "meta3";
  if (/(?:^\?|&)company_cd=000536(?:&|$)/.test(q)) return "google_sem";
  if (/(?:^\?|&)company_cd=000537(?:&|$)/.test(q)) return "pmax_google";
  if (/(?:^\?|&)company_cd=000543(?:&|$)/.test(q)) return "x";
  if (/(?:^\?|&)company_cd=000538(?:&|$)/.test(q)) return "tiktok";
  if (/(?:^\?|&)company_cd=000540(?:&|$)/.test(q)) return "meta2";
  if (/(?:^\?|&)company_cd=000542(?:&|$)/.test(q)) return "google_rda";
  if (/(?:^\?|&)company_cd=000539(?:&|$)/.test(q)) return 'yahoo_display';
  if (/(?:^\?|&)company_cd=000541(?:&|$)/.test(q)) return 'line';
  return null; // 該当なし
}

// -----------------------------------------------
// 媒体ごとの発火関数
// -----------------------------------------------
// Yahoo【000534】
// -----------------------------------------------
function fireYahooConversion() {
  console.log('[Yahoo] Conversion fired');

  if (typeof ytag !== 'function') {
    console.warn('[Yahoo] ytag is not defined.');
    return;
  }
  ytag({
    type: "yss_conversion",
    config: {
      yahoo_conversion_id: "1001384128",
      yahoo_conversion_label: "sTxzCLqqrdYbEKmF-ppC",
      yahoo_conversion_value: "0"
    }
  });

}
// -----------------------------------------------
// Meta【000535】
// -----------------------------------------------
function fireMetaConversion() {
  console.log('[Meta] Conversion fired (dual tags)');
  if (typeof fbq !== 'function') {
    console.warn('[Meta] fbq is not defined.');
    return;
  }
  fbq('trackSingle', '1680607133104868', 'SubmitApplication');
  fbq('trackSingleCustom', '2566372237082677', 'Applyclick');
}

function fireMeta3Conversion() {
  console.log('[Meta3] Conversion fired (dual tags)');
  if (typeof fbq !== 'function') {
    console.warn('[Meta3] fbq is not defined.');
    return;
  }
  fbq('trackSingle', '1680607133104868', 'SubmitApplication');
  fbq('trackSingleCustom', '2566372237082677', 'Applyclick');
}

// -----------------------------------------------
// Google Search【000536】
// -----------------------------------------------
function fireGoogleSemConversion(url) {
  console.log('[Google Search] Conversion fired');
  var callback = function () {
    if (typeof(url) !== 'undefined') {
      window.open(url, '_blank');
    }
  };
  gtag('event', 'conversion', {
    'send_to': 'AW-17707832787/Y4-sCL6Umb0bENOr4PtB',
    'event_callback': callback
  });

  return false;
}
// -----------------------------------------------
// PMAX Google【000537】
// -----------------------------------------------
function firePmaxGoogleConversion(url) {
  if (typeof gtag !== 'function') return;
  console.warn('[Pmax Google] Conversion fired (PMAX + RDA)');

  let opened = false;
  const openOnce = function () {
    if (opened) return;
    opened = true;
    try { window.open(url, '_blank'); } catch(e){}
  };

  gtag('event', 'conversion', {
    send_to: 'AW-17423045371/ZPkDCPT9jokbEPul-vNA',
    event_callback: openOnce
  });

  gtag('event', 'conversion', {
    send_to: 'AW-17707832787/ETgDCImTur4bENOr4PtB',
    event_callback: openOnce
  });
}
// -----------------------------------------------
// X（旧Twitter）【000543】
// -----------------------------------------------
function fireXConversion() {
  //console.warn('[X] Conversion fired');
  if (typeof twq !== 'function') return;
  twq('event', 'tw-qcuby-qcud3', {});
}
// -----------------------------------------------
// TikTok【000538】
// -----------------------------------------------
function fireTikTokConversion() {
  console.warn('[TikTok] Conversion fired');
  if (typeof ttq === 'undefined' || !ttq.instance) return;
  ttq.instance('D2K2V93C77U067DPRPC0').track('ClickButton');
}
// -----------------------------------------------
// 2608_UCプラチナカード_②申し込みボタン押下(TikTok)【000538、既存TikTokと併用】
// -----------------------------------------------
function fireTikTokApplyClickConversion() {
  console.log('[TikTok Apply Click] Conversion fired');
  if (typeof ttq === 'undefined' || !ttq.instance) return;
  ttq.instance('DA226UBC77UAAA42TOI0').track('ClickButton');
}
// -----------------------------------------------
// Meta2【000540】
// -----------------------------------------------
/** Meta2 押し下イベント */
function fireMeta2Conversion() {
  console.log('[Meta2] Conversion fired (dual tags)');
  
  if (typeof fbq !== 'function') {
    console.warn('[Meta2] fbq is not defined.');
    return;
  }
  fbq('trackSingle', '1680607133104868', 'SubmitApplication');
  fbq('trackSingleCustom', '2566372237082677', 'Applyclick');
}

// -----------------------------------------------
// Google Display（RDA）【000542】
// -----------------------------------------------
function fireGoogleRDAConversion(url) {
  console.log('[Google Display（RDA）] Conversion fired');
  gtag('event', 'conversion', {
    'send_to': 'AW-17707832787/ETgDCImTur4bENOr4PtB',
    'event_callback': function () {
      if (typeof(url) !== 'undefined') {
        window.open(url, '_blank');
      }
    }
  });
}
// -----------------------------------------------
// Yahoo! Display（YDN / yjad_conversion） 【000539】
// -----------------------------------------------
function fireYahooDisplayConversion() {
  console.log('[Yahoo Display] Conversion fired');
  if (typeof ytag !== 'function') {
    console.warn('[Yahoo Display] ytag is not defined.');
    return;
  }
  ytag({
    type: "yjad_conversion",
    config: {
      yahoo_ydn_conv_io: "S0yRJS9ObDZz3bNgtWPgCQ..",
      yahoo_ydn_conv_label: "KZR568OGHTZ3DWYZDP1284944",
      yahoo_ydn_conv_transaction_id: "",
      yahoo_ydn_conv_value: "0"
    }
  });
}
// -----------------------------------------------
// LINE（Base CodeはHTMLに設置済み、押し下はcv送信だけ）【000541】
// -----------------------------------------------
function fireLineConversion() {
  console.log('[LINE] Conversion fired');
  if (typeof _lt !== 'function') {
    console.warn('[LINE] _lt is not defined (base code not loaded?).');
    return;
  }
  _lt('send', 'cv', { type: 'Conversion' }, ['89f26dfe-9b1c-4baa-b87d-fd9e72f362c7']);
}
// -----------------------------------------------
// 2608_UCプラチナカード_②申し込みボタン押下(Meta)【000541、LINEと併用】
// -----------------------------------------------
function fireMetaApplyClickConversion() {
  console.log('[Meta Apply Click] Conversion fired');
  if (typeof fbq !== 'function') {
    console.warn('[Meta Apply Click] fbq is not defined.');
    return;
  }
  fbq('trackSingle', '1528610681871904', 'SubmitApplication');
}


/**
 * 各申込ボタンにクリックイベントを付与して、
 * URLパラメータ (company_cd) に応じて発火先を分岐
 */
function bindApplyConversion() {
  const applyBtns = document.querySelectorAll('.p-applyBtn a');
  const medium = detectMedium(); // 'pmax_google' | 'x' | 'tiktok' | null

  applyBtns.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      // --- 分岐発火 ---
      if (medium === 'meta') {
        fireMetaConversion();
      } else if (medium === 'meta3') {
        fireMeta3Conversion();
      } else if (medium === 'pmax_google') {
        firePmaxGoogleConversion(btn.href);
      } else if (medium === 'x') {
        fireXConversion();
      } else if (medium === 'tiktok') {
        fireTikTokConversion();
        fireTikTokApplyClickConversion(); // 000538は既存TikTokと新規TikTok両方に発火
      } else if (medium === 'google_sem') {
        fireGoogleSemConversion(btn.href);
      } else if (medium === 'google_rda') {
        fireGoogleRDAConversion(btn.href);
      } else if (medium === 'yahoo') {
        fireYahooConversion();
      } else if (medium === 'meta2') {
        fireMeta2Conversion();
      } else if (medium === 'yahoo_display') {
        fireYahooDisplayConversion();
      } else if (medium === 'line') {
        fireLineConversion();
        fireMetaApplyClickConversion(); // 000541はLINEとMeta両方に発火
      } else {
        // パラメータがない/一致しない場合は発火なし
        // ※ 全媒体発火したい場合は下行を有効化:
        // fireGoogleConversion(btn.href); fireXConversion(); fireTikTokConversion();
      }

      // 保険：callbackが動かなくても必ず新タブで開く
      setTimeout(() => {
        try { window.open(btn.href, '_blank'); } catch(e){}
      }, 300);
    });
  });
}

export default { init };
